import React from 'react'

// Capas em leque (sobrepostas), como o V1 apresenta o kit Educamos — pedido de
// negócio de 09/09 (item 3). Usado na seleção de produtos e no Resumo do pedido.
// Só apresentação: recebe os produtos e lê `images.GraficoBig` quando existir.
export default function V2CoverStack({ items = [], size = 96, max = 10, overlap = 0.62, align = 'center', badge = true }) {
  const covers = items.map(p => (p.images && p.images.GraficoBig) || null).filter(Boolean)
  const shown = covers.slice(0, max)
  const rest = items.length - shown.length
  const w = Math.round(size * 0.72)
  const step = Math.round(w * (1 - overlap))
  if (!shown.length) {
    return (
      <div style={{ display: 'flex', justifyContent: align, alignItems: 'center', height: size }}>
        <span style={{ fontFamily: 'ui-monospace,SFMono-Regular,Menlo,monospace', fontSize: '10px', color: '#8E8783' }}>capas do kit</span>
      </div>
    )
  }
  return (
    <div className="v2-cover-stack" style={{ display: 'flex', justifyContent: align, alignItems: 'flex-end', height: size, position: 'relative' }}>
      <div style={{ position: 'relative', width: w + step * (shown.length - 1), height: size, flex: 'none' }}>
        {shown.map((src, i) => (
          <img
            key={i}
            src={src}
            alt=""
            style={{ position: 'absolute', left: i * step, top: 0, width: w, height: size, objectFit: 'cover', borderRadius: '4px', border: '1px solid #fff', boxShadow: '0 2px 8px rgba(0,0,0,0.22)', zIndex: i }}
          />
        ))}
        {badge && rest > 0 && (
          <span style={{ position: 'absolute', right: -Math.round(size * 0.18), bottom: -Math.round(size * 0.08), minWidth: Math.round(size * 0.4), height: Math.round(size * 0.4), padding: '0 6px', borderRadius: '100px', background: '#D8262C', color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: 'Poppins,sans-serif', fontWeight: '600', fontSize: Math.max(11, Math.round(size * 0.16)), boxShadow: '0 2px 6px rgba(0,0,0,0.2)', zIndex: shown.length + 1 }}>
            +{rest}
          </span>
        )}
      </div>
    </div>
  )
}
